import React from 'react';

import Jumbotron from 'components/modules/box/Jumbotron';
import JumbotronPanel from 'components/modules/box/JumbotronPanel';

import CSSModule from './AnnouncementDetailRestricted.module.scss';

const AnnouncementDetailRestricted: React.FC = () => (
  <div className={CSSModule.AnnouncementDetailRestricted}>
    <Jumbotron>
      <JumbotronPanel
        title="お知らせ機能を利用できません"
        description="契約手続きが未完了もしくは団体会員コード未登録のため利用できません。学校にお問い合わせください。"
      />
    </Jumbotron>
  </div>
);

export default AnnouncementDetailRestricted;
